import { PanoramaFlight } from "@nova/protobuf"
import { generateGenericCases } from "../../generateCases"
import { Builder } from "../../sockets"
import {
    CreatePanoramaFlightArgs,
    getDefaultPanoramaFlightCreateArgs,
    UpdatePanoramaFlightArgs,
} from "@nova/serializer/src/client/validators/flights/panorama"
import { selectPanoramaFlights } from "features/entity-caching/flights/selectors"
import {
    addEntitySocket,
    deleteEntitySocket,
    updateEntitySocket,
} from "features/entity-caching/project/slice"
import { v4 as randomUUID } from "uuid"
import { setFlightId } from "features/map/control/slice"
import { deleteUploadSet } from "plugins/Panorama/PanoramaSlice"
import { SampleDataFlightKey } from "@nova/constants"
import {
    selectSingleLayer,
    setActiveFeatureId,
    setActiveLayerId,
} from "panels/content/side-panel/slice.new"
import { NovaPluginIds } from "panels/controls/PluginAccessPanel/constants"

const {
    create: createPanoramaFlight,
    update: updatePanoramaFlight,
    delete: deletePanoramaFlight,
    createAction,
    updateAction,
    deleteAction,
} = generateGenericCases<
    PanoramaFlight, // entity type
    CreatePanoramaFlightArgs, // create args to send to server
    ["createdBy"], // create args required by action
    UpdatePanoramaFlightArgs, // update args
    { sampleDataFlightKey?: SampleDataFlightKey },
    { sampleDataFlightKey?: SampleDataFlightKey }
>("PanoramaFlight")
export const addPanoramaFlightsToBuilder = (builder: Builder) =>
    builder
        .addCase(createAction, (store, { payload: { data, context } }, socket) => {
            const state = store.getState()
            const flights = selectPanoramaFlights(state)
            const name = `Panorama ${flights.length + 1}`
            const args = {
                name,
                id: randomUUID(),
                demoId: !!context?.sampleDataFlightKey ? "doesnt-matter" : undefined,
            }
            const optimisticData = {
                ...args,
                ...getDefaultPanoramaFlightCreateArgs(state.project.data),
                ...data,
            }
            createPanoramaFlight(
                socket,
                { ...args, ...data },
                { sampleDataFlightKey: context?.sampleDataFlightKey }
            )
            store.dispatch(
                addEntitySocket({
                    data: optimisticData,
                    path: ["panoramaFlights"],
                })
            )

            store.dispatch(selectSingleLayer({ id: optimisticData.id }))
            store.dispatch(setFlightId(optimisticData.id))
            store.dispatch(setActiveLayerId({ id: optimisticData.id }))
            store.dispatch(setActiveFeatureId({ feature: NovaPluginIds.Panorama }))
        })
        .addCase(updateAction, (store, { payload: { id, updates, context } }, socket) => {
            updatePanoramaFlight(socket, id, updates, { ...context })

            if (context?.sampleDataFlightKey) updates.demoId = "doesnt-matter"

            store.dispatch(updateEntitySocket({ updates, path: ["panoramaFlights", { id }] }))
        })
        .addCase(deleteAction, (store, { payload: { id } }, socket) => {
            const dispatch = store.dispatch
            dispatch(deleteUploadSet({ flightId: id }))
            deletePanoramaFlight(socket, id, {})
            dispatch(deleteEntitySocket({ path: ["panoramaFlights", { id }] }))
        })
export {
    createAction as createPanoramaFlight,
    updateAction as updatePanoramaFlight,
    deleteAction as deletePanoramaFlight,
}
